// extracted by mini-css-extract-plugin
module.exports = {"button":"search-button-m__button__3TxrP"};